import React from "react";
import { Link } from "react-router-dom";
import { Panel, PanelBody } from "../components/panel/panel.jsx";
import { Api } from "../app-controller.js";
import Swal from "sweetalert2";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

import ModalFormulario from "../components/PrecertificadoCE/ModalFormularioAutorizacion";

class AutorizacionAdquisicion extends React.Component {
  initialState = {
    openModal: false,
    buscar: {},
    procesando: false,

    solicitud_id: "",
    folio_solicitud: "",
    establecimiento_id: "",
    option_productos: [],
    presentaciones: [],
    medio_transportes: Api.loadCatalogue("cat_tipo_vehiculo"),
    locations: Api.loadCatalogue("locations"),
    estatusTramiteCombo:[
      {id:"3", descripcion: "Llenar información"},
      {id:"1", descripcion: "En espera"},
      {id:"5", descripcion: "Aceptada"},
      {id:"4", descripcion: "Rechazada"}
    ],

    productos: [],
    producto: {
      id: "",
      nombre_comercial: "",
      presentacion_id: "",
      presentacion: "",
      presentacion_cantidad: "",
      presentacion_unidad_medida: "",
      cantidad: "",
      kilogramos: "",
    },
    destino: {
      planta_destino: "",
      nombre_conductor: "",
      apellido_conductor: "",
      cedula: "",
      medio_transporte_id: "",
      no_placa: "",
      //no_marchamo: "",
      ciudad: "",
      departamento_id: "",
    },
  };

  constructor(props) {
    super(props);

    this.state = this.initialState;

    this.OpenModal = this.OpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.limpiarCampos = this.limpiarCampos.bind(this);
    this.mensajeError = this.mensajeError.bind(this);

    this.addProducto = this.addProducto.bind(this);
    this.removeProducto = this.removeProducto.bind(this);

    this.handleChangeProducto = this.handleChangeProducto.bind(this);
    this.handleChangeConductor = this.handleChangeConductor.bind(this);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  mi_grid = {};
  componentDidMount() {
    let grid = {
      source: "app/getSolicitudesAdquisicionCliente",
      target: "#myGrid",
      tableClass: "table table-striped m-b-0 table-hover",
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando datos",
      rows: {
        folio_solicitud: {
          label: "Folio Solicitud",
        },
        razon_social: {
          label: "Establecimiento",
        },
        fecha_solicitud: {
          label: "Fecha Solicitud",
          render: (me) => {
            me.innerHTML = me.data.fecha_solicitud
              .split(" ")[0]
              .split("-")
              .reverse()
              .join("-")
              .replaceAll("-", "/");
          },
        },
        estatus_tramite: {
          label: "Estatus",
          render: (me) => {
            if (me.data.estatus_tramite_id === "3") {
              me.innerHTML= 'Llenar información';
            }else if (me.data.estatus_tramite_id === "9" || me.data.estatus_tramite_id === "17"){
              me.innerHTML= 'En espera';
            }
          },
        },
      },
      buttons: [
        {
          iconClass: "fa fa-list",
          btnClass: "btn bg-gradient-green",
          btnClick: (data) => {
            this.setState({
              folio_solicitud: data.folio_solicitud,
              establecimiento_id: data.establecimiento_id,
              solicitud_id: data.id,
            });

            this.OpenModal(data);
          },
          render: (me, data) => {
            if (data.estatus_tramite_id !== "3") {
              me.remove();
            }
          },
        },
      ],
    };

    this.mi_grid = Api.grid(grid);

    let busqueda = Api.form({
      target: "#busqueda",
      render: (form) => {},
      elementClass: "form-control",
      elements: [
        {
          input: {
            type: "text",
            name: "folio_solicitud",
            label: "Folio solicitud",
            placeHolder: "Folio solicitud",
            cols: 6,
            value: "",
          },
        },
        {
          input: {
            type: "text",
            name: "razon_social",
            label: "Establecimiento",
            placeHolder: "Establecimiento",
            cols: 6,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha",
            label: "Fecha desde",
            cols: 3,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha2",
            label: "Fecha hasta",
            cols: 3,
            value: "",
          },
        },
        {
          select: {
            cols: 3,
            name: "estado",
            label: "Estado",
            render: (me) => {
              me.innerHTML=`<option value="">Seleccione</option>`;
                this.state.estatusTramiteCombo.forEach(s=>{
                  me.innerHTML+=`<option value="${s.id}">${s.descripcion}</option>`;
              })
            },
          },
        },
        {
          button: {
            name: "buscar",
            class: "form-control btn-orange",
            icon: "fa fa-search",
            cols: 3,
            text: "Buscar",
            click: (e) => {
              this.setState({ buscar: busqueda.data() });
              let search = this.state.buscar;

              let src = "";
              for (let param in search) {
                if (search[param] !== "") {
                  src += "&" + param + "=" + search[param];
                }
              }

              this.mi_grid.go(1, src);
            },
          },
        },
      ],
    });
  }

  OpenModal(data) {
    Api.loading(true);
    Api.fetch(
      "app/getProductosFabricante?establecimiento_id=" +
        this.state.establecimiento_id
    ).then((pro) => {
      if (pro) {
        this.setState({
          openModal: true,
          option_productos: pro,
          establecimiento_id: data.establecimiento_id,
        });
      }
      Api.loading(false);
    });
  }

  /**
   * limpiar 1, no limpiar 0
   */
  closeModal(limpiar) {
    Swal.fire({
      title: "¿Seguro que quiere cerrar el formulario de autorización de adquisición?",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "red",
      confirmButtonColor: "#4CD964",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ openModal: false });
        if (limpiar === 1) {
          this.limpiarCampos(1);
        }
      }
    });
  }

  limpiarCampos(e) {
    this.setState({ ...this.initialState });
  }

  mensajeError(titulo, msg) {
    Swal.fire({
      title: titulo,
      icon: "warning",
      text: msg,
    });
  }

  addProducto(pro) {
    let producto = { ...this.state.producto };
    let productos = [...this.state.productos];
    let agregar = 1;

    /** Puede estar el mismo producto en la lista solo con otra presentacion */
    for (let p in producto) {
      if (producto[p] === "" && (p !== "nombre_comercial")) {// si alguno de mis atributos esta vacio, no agrego
        this.mensajeError("Atención", "Revisar que no falte nada en el producto.");
        agregar = 0;
        return false;
      }
    }

    if (agregar) {
      for (let p in productos) {
        if (productos[p].id === producto["id"]) {
          if (productos[p].presentacion_id === producto["presentacion_id"]) {
            this.mensajeError("Atención", "Ya se encuentra en su lista.");
            agregar = 0;
            return false;
          }
        }
      }

      if (agregar) {
        if (producto["cantidad"] !== "") {
          //buscamos la info del producto
          Api.fetch("app/getProductoInfo?id=" + producto["id"]).then((data) => {
            if (data) {
              producto["no_registro"] = data[0].no_registro;
              producto["nombre_comercial"] = data[0].nombre_comercial;

              productos.push(producto);
              producto = this.initialState.producto;
              this.setState({
                productos: productos,
                producto: producto,
                presentaciones: [],
              });
            }
          });
        }
      }
    }
  }

  removeProducto(e) {
    let productos = [...this.state.productos];
    productos.splice(e.target.id, 1);
    this.setState({ productos: productos });
  }

  handleChangeProducto(e) {
    let prod = { ...this.state.producto };

    if (e.target.name === "id") {
      if(e.target.value !== ""){     
        Api.fetch(
          //buscar precentaciones
          "app/getProductPresentation?producto_id=" + e.target.value
        ).then((response) => {
          if (response) {
            this.setState({ presentaciones: response });
          }
        });
      }else{
        prod = {...this.initialState.producto};
        this.setState({ presentaciones: [] });
      }
    }

    if (e.target.name === "presentacion_id") {
      let empaque_name = this.state.presentaciones.find(
        (d) => d.id === e.target.value //trae el id del producto
      );

      if (empaque_name) {
        prod["presentacion"] = empaque_name.empaque;
        prod["presentacion_unidad_medida"] = empaque_name.unidad_medida;
        prod["presentacion_cantidad"] = empaque_name.cantidad;
      }
    }

    if (e.target.name === "cantidad") {
      let entero = /^[1-9]\d*$/;
      if (e.target.value === "" || entero.test(e.target.value)) {
        prod["cantidad"] = e.target.value;
        this.setState({ producto: prod });
      } else {
        return;
      }
    }

    if (e.target.name === "kilogramos") {
      let rx_live =
        /^(\$|)([0]?||[1-9]\d{0,2}(\d{3})*|([1-9]\d*))(\.\d{0,2})?$/;
      if (e.target.value === "" || rx_live.test(e.target.value)) {
        prod["kilogramos"] = e.target.value;
        this.setState({ producto: prod });
      } else {
        return;
      }
    }

    prod[e.target.name] = e.target.value;
    this.setState({ producto: prod });
  }

  handleChangeConductor(e) {
    let destino = { ...this.state.destino };
    destino[e.target.name] = e.target.value.toUpperCase();
    this.setState({ destino: destino });
  }

  handleSubmit(e) {
    e.preventDefault();
    let valido = 1;
    let destino = this.state.destino;
    let obj_enviar = {
      establecimiento_id: this.state.establecimiento_id,
      solicitud_id: this.state.solicitud_id
    };
    
    for (let d in destino) {
      if (destino[d] === "" /* && (d !== "no_marchamo") */) {// si alguno de mis atributos esta vacio, no agrego
        this.mensajeError("Atención", "Favor de revisar que no falte nada en la información destino.");
        valido = 0;
      }else{
        obj_enviar[d] = destino[d];
      }
    }

    if(this.state.productos.length === 0){
      this.mensajeError("Atención", "Favor de agregar como mínimo un producto.");
      valido = 0;
    }else{
      obj_enviar['productos'] = this.state.productos;
    } 

    let municipio = this.state.locations.municipios.find(
      (d) => d.id === parseInt(this.state.destino.ciudad) //trae el id del producto
    );
    obj_enviar["ciudad"] = municipio.name;


    if(valido){
      Swal.fire({
        title: "¿Seguro que desea realizar la solicitud?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Regresar",
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          Api.loading(true);

          Api.fetch(
            "app/generarSubproductoAutorizacion", obj_enviar, "POST")
            .then((data) => {
              Api.loading(false);
              Swal.fire({
                icon: "success",
                title: data.message,
                timer: 3000,
              }).then(() => {
                this.mi_grid.go(1);
                this.setState({ openModal: false });
                this.limpiarCampos(1);
              });
            }).catch((error) => {
              error.json().then((message) => {
                Api.loading(false);
                Swal.fire({
                  title: "Ocurrió un error al procesar la solicitud",
                  icon: "error",
                  text: "Revise la información e intente de nuevo su última acción.", //message,
                });
                this.setState({ procesando: false });
              }); //catching errors to show notification
            });
        }
      }); 
    }
  }

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/">Inicio</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/subproductos/precertificado-constancia-exportacion">Subproductos</Link>
          </li>
          <li className="breadcrumb-item active">
            Autorización de adquisición
          </li>
        </ol>
        <h1 className="page-header">Autorización de adquisición</h1>
        <Panel>
          <PanelBody>
            <div className="row">
              <div className="col-sm-12">
                <fieldset>
                  <div id="busqueda"></div>
                </fieldset>
                <div id="myGrid"></div>
              </div>
            </div>
          </PanelBody>
        </Panel>

        {/**Modal del formulario */}
        <Modal
          isOpen={this.state.openModal}
          tabIndex="-1"
          style={{
            maxWidth: "100%",
            width: "85%",
          }}
        >
          <ModalHeader
            toggle={() => {
              this.closeModal(1);
            }}
            className="text-center"
          >
            Folio: {this.state.folio_solicitud}
          </ModalHeader>
          <ModalBody>
            <ModalFormulario
              key={this.state.solicitud_id}
              component={this}
              state={this.state}
            />
          </ModalBody>
        </Modal>
        <div
          className={
            this.state.procesando ? "progress rounded-corner m-b-15" : "hide"
          }
        >
          <div
            className="progress-bar bg-purple progress-bar-striped progress-bar-animated"
            style={{ width: "100%", height: "20px" }}
          >
            <h4>Cargando, espere...</h4>
          </div>
        </div>
      </div>
    );
  }
}

export default AutorizacionAdquisicion;
